export default __webpack_public_path__ + "static/media/GT-America-Standard-Regular.0c23b354.otf";